import { render } from "./PanelClienteCuenta.vue?vue&type=template&id=8b3deaba&scoped=true"
import script from "./PanelClienteCuenta.vue?vue&type=script&lang=js"
export * from "./PanelClienteCuenta.vue?vue&type=script&lang=js"

import "./PanelClienteCuenta.vue?vue&type=style&index=0&id=8b3deaba&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3deaba"]])

export default __exports__